/**
 * Shared API types for error handling
 */

export enum LimitErrorType {
  DAILY_LIMIT_EXCEEDED = 'DAILY_LIMIT_EXCEEDED'
}

export interface ApiErrorResponse {
  error: string;
  message: string;
  limitCheck?: {
    canGenerate: boolean;
    currentCount: number;
    maxAllowed: number;
    limitType?: LimitErrorType;
    nextAvailableDate?: string;
  };
}
